import { gql, type TypedDocumentNode } from '@apollo/client';


export const IS_ACTIVITY_ACCEPTED_QUERY: TypedDocumentNode<IIsActivityAcceptedQueryData, IIsActivityAcceptedQueryVars>  = gql`
    query IS_ACTIVITY_ACCEPTED_QUERY($activityId: Long!, $providerId: Long!) {
        isActivityAcceptedByProvider(activityId: $activityId, providerId: $providerId)
    }
`
export interface IIsActivityAcceptedQueryVars {
    activityId: number;
    providerId: number;
}

export interface IIsActivityAcceptedQueryData {
    isActivityAcceptedByProvider: boolean
};